import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  mode: 'light',
  background: '#ffffff',
  surface: '#ffffff',
  surfaceAlt: '#f8f9fa',
  text: '#222222',
  textSecondary: '#666666',
  primary: '#007bff',
  border: '#e6e6e6',
  mutedBg: '#f0f0f0',
  shadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  hoverShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
  headerBg: 'rgba(255, 255, 255, 0.92)',
  footerBg: '#111111',
  footerText: '#ffffff',
};

export const darkTheme: DefaultTheme = {
  mode: 'dark',
  background: '#0f1216',
  surface: '#151a21',
  surfaceAlt: '#0f1216',
  text: '#f2f4f8',
  textSecondary: '#aab0bb',
  primary: '#4dabf7',
  border: '#2a3240',
  mutedBg: '#222a36',
  shadow: '0 6px 18px rgba(0, 0, 0, 0.35)',
  hoverShadow: '0 10px 26px rgba(0, 0, 0, 0.45)',
  headerBg: 'rgba(21, 26, 33, 0.78)',
  footerBg: '#0b0e12',
  footerText: '#dfe3ea',
}; 